<template>
    <div id="requestViewer" class="base" v-if="!isloading">
        <div v-if="!showLoginflg">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke"></div>
        </div>
        <div class="regist-area">
            <div v-if="isQueryError" id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                    <div style="color: whitesmoke">
                        指定されたページはURLが間違っているか、有効期限が切れています。
                    </div>
                </div>
            </div>
            <div v-else-if="!isAuthed" id="item-contens">
                <div class="card-content auth-area">
                    <div style="font-size: 20px; color: whitesmoke">パスワード</div>
                    <input type="password" v-model="password"/>
                    <div v-if="authFaild" class="authFaild">{{ errMessage }}</div>
                    <b-button class="opbutton" icon-left="chevron-double-right" @click="auth" :disabled="!password">ログイン</b-button>
                </div>
            </div>
            <div v-else id="item-contens">
                <div style="maragin-bottom:20px;">
                    <div style="font-size: 20px; color: whitesmoke; margin-bottom:10px;">申込み概要</div>
                    <hstRequestDetail v-if="requestType == `hst`"
                        :data="showDetailTargetData" 
                        style="padding:20px;"/>
                    <psgRequestDetail v-if="requestType == `psg`"
                        :data="showDetailTargetData"
                        :canUpdate="false"
                        style="padding:20px;"/>
                    <kenshinRequestDetail  v-if="requestType == `kenshin`"
                        :data="showDetailTargetData"
                        :isAccommodations="isAccommodations"
                        style="padding:20px;"/>
                    <holterRequestDetail  v-if="requestType == `holter`"
                        :data="showDetailTargetData"
                        :isHideAnalysisOptions="true"
                        style="padding:20px;"/>
                    <holterAnalysisRequestDetail  v-if="requestType == `holterAnalysis`"
                        :data="showDetailTargetData"
                        :canUpdate="false"
                        style="padding:20px;"/>
                    <cpapRequestDetail v-if="requestType == `cpap`"
                        :data="showDetailTargetData"
                        :showRequestInfo="true"
                        :isMasterAcquisition="false"
                        :viewerFlg="true"
                        style="padding:20px;"/>
                </div>
            </div>
        </div>
        </div>
        <div v-else-if="showLoginflg">
                <login v-if="showLoginflg" :result="result" @close-login="closeLogin"></login>
        </div>
    </div>
</template>

<script>
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import PSGRequestDetail from "@/components/mock/common/PSGRequestDetail";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import HolterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import login from '@/components/mock/login';

export default {
  name: "requestViewer",
  data() {
    var query = this.$route.query.key;
    var showLoginflg = this.$route.hash ? true: false;
    return {
        data:{},
        query:query,
        isloading: true,
        isQueryError: true,
        isAuthed: false,
        authFaild: false,
        password: "",
        requestType: "",
        showDetailTargetData: {},
        isAccommodations:false,
        showLoginflg:showLoginflg,
        errMessage: ""
    };
  },
  methods: {
    closeLogin(result) {
        // ログイン成功で非表示にする
        this.showLoginflg = false;
        this.isAuthed = true;
        this.setRequestData(result);
    },
    auth: function() {
        try {
            this.$store.dispatch("requestViewerAuth", {
                key: this.query,
                password: this.password
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.setRequestData(result);
                    this.isAuthed = true;
                } else if (result.status === 500) {
                    //システムエラーが発生しました。
                    this.errMessage = result.response.obj.message;
                } else if (result.status === 400) {
                    //パスワードが違います。
                    this.errMessage = result.response.obj.message;
                    this.authFaild = true;
                } else if (result.status === 402) {
                    //対象の申込みはキャンセルされています。
                    this.errMessage = result.response.obj.message;
                    this.authFaild = true;
                } else {
                    this.errMessage = "システムエラーが発生しました。";
                    this.authFaild = true;
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        }
    },
    setRequestData: function(result) {
        //申請内容を設定
        if(result.obj.hst) {
            this.requestType = "hst";
            this.showDetailTargetData = result.obj.hst;
        } else if(result.obj.psg) {
            this.requestType = "psg";
            this.showDetailTargetData = result.obj.psg;
        } else if(result.obj.kenshin) {
            this.requestType = "kenshin";
            this.showDetailTargetData = result.obj.kenshin;
            this.isAccommodations = this.showDetailTargetData.isAccommodations
        } else if(result.obj.holter) {
            this.requestType = "holter";
            this.showDetailTargetData = result.obj.holter;
        } else if(result.obj.cpap) {
            this.requestType = "cpap";
            this.showDetailTargetData = result.obj.cpap;
        }
    },
  },
  computed: {
  },
  mounted: function(){
    //keyの検証
    try {
        this.$store.dispatch("getChoiceMaster", {
        }).then(result => {
        }).catch(error => {
        });
        this.$store.dispatch("getPrescriptionHardware", {
        }).then(result => {
        }).catch(error => {
        });
        this.$store.dispatch("getCpapStatus", {
        }).then(result => {
        }).catch(error => {
        });
        this.$store.dispatch("verifyKeyForRequestViewer", {
            key: this.query
        }).then(result => {
            if(result != null && result.status === 200 ) {
                this.isQueryError = false
            } else {
                this.showLoginflg = false;
            }
            this.isloading = false;
            //backgroundの変更
            document.documentElement.style.background = "rgb(0, 114, 218)";
        }).catch(error => {
            this.isloading = false;
        });
    } catch(err){
        this.isloading = false;
    }
  },
  components: { 
    hstRequestDetail:HSTRequestDetail,
    psgRequestDetail:PSGRequestDetail,
    kenshinRequestDetail:KenshinRequestDetail,
    holterRequestDetail:HolterRequestDetail,
    holterAnalysisRequestDetail:HolterAnalysisRequestDetail,
    cpapRequestDetail:CpapRequestDetail,
    login: login,
  },
};
</script>
<style lang="scss" scoped>
.base {
    min-height: 1000px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 600px;
}
.auth-area {
    width: 350px !important;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.summaryArea
{
    min-height: 450px;
}

.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.authFaild{
    margin-top:5px;
    color:tomato;
}
.opbutton {
    margin-top:10px;
    width: 100px;
}
#PSGRequestDetail,
#HSTRequestDetail,
#KenshinRequestDetail,
#HolterRequestDetail,
#HolterAnalysisRequestDetail,
#CpapRequestDetail{
    background-color: whitesmoke;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/guest/requestUrl/requestViewer.vue